import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { MatterDto } from '@shared/interfaces/dtos/matters';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MattersService extends BaseHttpService {
  protected endPoint: string = 'Global/Matieres';

  public fetchMatters(): Observable<MatterDto[]> {
    return this.http.get<MatterDto[]>(this.buildURL());
  }
}
